import { render, staticRenderFns } from "./lists.vue?vue&type=template&id=33b3e625&"
import script from "./lists.vue?vue&type=script&lang=js&"
export * from "./lists.vue?vue&type=script&lang=js&"
import style0 from "./lists.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports